<template>
  <mds-card title="">
    <schedule-status
      class="activitylog-tab__status"
      tinted
      :status="mappedActivity.status"
      :item-id="mappedActivity.job_id"
    />
    <mds-list-group>
      <div class="activitylog-tab__content">
        <mds-icon name="play-circle" size="small" />
        <mds-list-group-item
          class="activitylog-tab__title"
          :text="
            translate('flyover.schedules.activityLog.card.startTime.label')
          "
          :microcopy="displayDate(mappedActivity.start_time, TIMES.startTime)"
        />
      </div>
      <div class="activitylog-tab__content">
        <mds-icon name="stop-circle" size="small" />
        <mds-list-group-item
          class="activitylog-tab__title"
          :text="translate('flyover.schedules.activityLog.card.endTime.label')"
          :microcopy="displayDate(mappedActivity.end_time, TIMES.endTime)"
        />
      </div>
      <div class="activitylog-tab__content">
        <mds-icon name="info-circle" size="small" />
        <mds-list-group-item
          class="activitylog-tab__title"
          :text="translate('flyover.schedules.activityLog.card.jobId.label')"
          :microcopy="mappedActivity.job_id"
        />
      </div>
    </mds-list-group>
  </mds-card>
</template>

<script>
import MdsCard from '@mds/card'
import MdsIcon from '@mds/icon'
import { MdsListGroup, MdsListGroupItem } from '@mds/list-group'
import { formatDate } from '../../../../utils/date'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import defaultConfig from '../../config/i18n'
import { STATUS } from '../../../../utils/scheduleMapper'
import { VIEWS, IN_PROGRESS_STATUS, TIMES } from '../../config/constants'
import ScheduleStatus from '../../../scheduleStatus/ScheduleStatus.vue'

export default {
  name: 'ActivityCard',
  components: {
    MdsCard,
    MdsListGroup,
    MdsListGroupItem,
    MdsIcon,
    ScheduleStatus,
  },
  mixins: [MwcBaseHelpersMixin],
  data() {
    return {
      defaultConfig,
      mappedActivity: {},
      TIMES,
    }
  },
  created() {
    const { status, ...rest } = this.activity
    this.mappedActivity = {
      ...rest,
      status: STATUS[status] ?? STATUS['NOT-STARTED'],
    }
  },
  props: {
    activity: {
      type: Object,
      default: () => ({}),
    },
    view: {
      type: String,
      default: '',
    },
  },
  methods: {
    displayDate(runningDate, dateType) {
      const defaultValue = '—'
      const slicedDate =
        runningDate.length > 19 ? runningDate.slice(0, 19) : runningDate
      if (
        dateType === TIMES.endTime &&
        this.view === VIEWS.feeds &&
        this.activity.status === IN_PROGRESS_STATUS
      ) {
        return defaultValue
      }

      if (slicedDate !== 'NA' && slicedDate) {
        const { date, time, timezone, utcOffset } = formatDate(`${slicedDate}Z`)
        return `${date}
        <br>
        ${time} ${timezone} (${utcOffset})`
      }

      return defaultValue
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@mds/constants';
@import '@mds/typography';

.activitylog-tab {
  &__status {
    margin-bottom: $mds-space-1-x;
  }
  &__content {
    display: flex;
    &::v-deep [class^='mds-icon'] {
      padding-top: $mds-space-quarter-x;
      margin-right: $mds-space-1-x;
    }
  }
  &__title {
    margin-bottom: $mds-space-half-x;
    &::v-deep [class^='mds-list-group-item__upper'] {
      display: flex;
      > span {
        @include mds-body-text-s();
        color: $mds-text-color-primary;
      }
    }
    &::v-deep [class^='mds-list-group-item__microcopy'] {
      @include mds-body-text-s();
      color: $mds-text-color-secondary;
    }
  }
}
</style>
